import React from 'react';


// Internal Import
import { ResponseRegister } from '../modules/types/register.type';
import { DialogStatusComponent, DialogStatusProps } from '../components/dialog';

// External Import
import * as Yup from 'yup';
import { useFormik } from 'formik';
import instance from '../modules/axios';
import { common } from "@mui/material/colors";
import LoadingButton from '@mui/lab/LoadingButton';
import { Link, useNavigate } from 'react-router-dom';

import {
    Box,
    Stack,
    Button,
    TextField,
    Typography,
} from '@mui/material';


const dot = [1, 2, 3];

export interface RegeisterProps { }
export const RegisterScreen: React.FC<RegeisterProps> = () => {

    let navigate = useNavigate();

    const [loading, setLoading] = React.useState<boolean>(false);
    
    const [dialog, setDialog] = React.useState<DialogStatusProps>({
        open: false,
        message: "",
        screen: "login",
        status: 'error',
    });
    const handleCloseDialog = () => { setDialog({ ...dialog, open: false }); }

    const formik = useFormik({
        initialValues: {
            fullname: '',
            phone: '',
            email: '',
            password: '',
            repassword: '',
            submit: null
        },
        validationSchema: Yup.object({
            fullname: Yup
                .string()
                .required('Fullname is required'),
            phone: Yup
                .string()
                .min(10)
                .required('Phone is required'),
            email: Yup
                .string()
                .email('Must be a valid email')
                .max(50)
                .required('Email is required'),
            password: Yup
                .string()
                .min(8, 'Password is too short - should be 8 chars minimum.')
                .required('Password is required.'),
            repassword: Yup
                .string()
                .oneOf([Yup.ref('password')], 'Passwords must match')
                .required('Re-Password is required.'),
        }),
        onSubmit: async (values, helpers) => {
            let userFormData = new FormData();
            userFormData.append("fullname", values.fullname);
            userFormData.append("phone", values.phone);
            userFormData.append("email", values.email);
            userFormData.append("password", values.password);
            userFormData.append("code_country", '+62');

            setLoading(true);

            handleApiRegister(userFormData);
        }
    });

    const handleApiRegister = async (data: FormData) => {
        try {
            const response: any = await instance.post('auth/register.php', data, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            let dtResponse: any = response?.data;

            let dataResponse: ResponseRegister = {
                status: dtResponse?.status,
                message: dtResponse?.message,
            }

            if (dataResponse.status == 200) {
                setLoading(false);

                setDialog({
                    ...dialog,
                    open: true,
                    status: 'success',
                    message: dataResponse.message
                });
                setTimeout(() => {
                    handleCloseDialog();
                    navigate('/login');
                }, 1500);
                return;
            } else if (dataResponse.status > 400) {
                setLoading(false);
                setDialog({
                    ...dialog,
                    open: true,
                    status: 'error',
                    message: dataResponse.message
                });
                return;
            }

            setLoading(false);
            setDialog({
                ...dialog,
                open: true,
                status: 'error',
                message: 'Login Failed: Something problem, please try again!'
            });
        } catch (error) {
            setLoading(false);
            setDialog({
                ...dialog,
                open: true,
                status: 'error',
                message: 'Login Failed: Something problem, please try again!'
            });
        }

    }


    return (
        <div>
            <Stack direction='row'>

                {/* // Contain Left // */}
                <Box
                    sx={{
                        display: 'flex',
                        flex: '1 1 auto',
                        minHeight: '100vh',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingTop: { xs: 6, md: 3 },
                        paddingLeft: { xs: 4, md: 0, lg: 0 },
                        paddingRight: { xs: 4, md: 0, lg: 0 },
                        paddingBottom: { xs: 6, md: 3 },
                    }}
                >
                    <Box sx={{ width: '100%', maxWidth: 550 }}>
                        <div>
                            <Stack spacing={1} sx={{ mb: 3 }}>
                                <Box sx={{ display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
                                    <img
                                        alt="Logo Ciputra"
                                        src="/assets/logos/ciputra.png"
                                        style={{
                                            height: 18,
                                            marginBottom: 16,
                                            display: 'inline-block'
                                        }}
                                    />
                                </Box>
                                <Typography variant="h4">
                                    Register Now.
                                </Typography>
                                <Typography color="text.secondary" variant="body2">
                                    Create your account, it takes less than a minute.
                                    Already have an account?
                                    &nbsp;
                                    <Link
                                        to="/login"
                                        style={{
                                            color: '#008060',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        Login
                                    </Link>
                                </Typography>
                            </Stack>
                            <form noValidate onSubmit={formik.handleSubmit}>
                                <Stack spacing={3}>
                                    <TextField
                                        fullWidth
                                        name="fullname"
                                        type="text"
                                        label="Fullname"
                                        placeholder='Your Fullname'
                                        onBlur={formik.handleBlur}
                                        value={formik.values.fullname}
                                        onChange={formik.handleChange}
                                        error={!!(formik.touched.fullname && formik.errors.fullname)}
                                        helperText={formik.touched.fullname && formik.errors.fullname}
                                    />
                                    <TextField
                                        fullWidth
                                        name="phone"
                                        type="text"
                                        label="Phone"
                                        placeholder='Your Phone'
                                        onBlur={formik.handleBlur}
                                        value={formik.values.phone}
                                        onChange={formik.handleChange}
                                        error={!!(formik.touched.phone && formik.errors.phone)}
                                        helperText={formik.touched.phone && formik.errors.phone}
                                    />
                                    <TextField
                                        fullWidth
                                        name="email"
                                        type="email"
                                        label="Email Address"
                                        placeholder='Your Email'
                                        onBlur={formik.handleBlur}
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        error={!!(formik.touched.email && formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                    />
                                    <TextField
                                        fullWidth
                                        name="password"
                                        type="password"
                                        label="Password"
                                        onBlur={formik.handleBlur}
                                        placeholder='Your Password'
                                        onChange={formik.handleChange}
                                        value={formik.values.password}
                                        error={!!(formik.touched.password && formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                    />
                                    <TextField
                                        fullWidth
                                        name="repassword"
                                        type="password"
                                        label="Re-Password"
                                        onBlur={formik.handleBlur}
                                        placeholder='Re-type Your Password'
                                        onChange={formik.handleChange}
                                        value={formik.values.repassword}
                                        error={!!(formik.touched.repassword && formik.errors.repassword)}
                                        helperText={formik.touched.repassword && formik.errors.repassword}
                                    />
                                </Stack>
                                <LoadingButton
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    sx={{ mt: 3 }}
                                    startIcon={<></>}
                                    loading={loading}
                                    disabled={loading}
                                    variant="contained"
                                    loadingPosition='start'
                                >
                                    {loading ? "Please wait..." : "Register"}
                                </LoadingButton>
                            </form>
                        </div>
                    </Box>
                </Box>

                {/* // Contain Right // */}
                <Box
                    sx={{
                        width: '35vw',
                        margin: '2vw',
                        alignItems: 'center',
                        borderRadius: '1.5vw',
                        justifyContent: 'center',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        display: { xs: 'none', md: 'none', lg: 'flex' },
                        backgroundImage: 'url(./assets/images/interior-house.jpg)'
                    }}
                >
                    <Box
                        sx={{
                            flex: '1',
                            height: '100%',
                            display: 'flex',
                            borderRadius: '1.5vw',
                            flexDirection: 'column',
                            backgroundColor: 'rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        <Box style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-evenly',
                        }}>
                            <Typography
                                variant="h2"
                                color={common.white}
                                sx={{
                                    padding: 2,
                                    marginLeft: 4,
                                    marginRight: 4,
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'rgba(255, 255, 255, 0.25)'
                                }}
                            >
                                Discover and own the best properties by Ciputra
                            </Typography>
                            <Box sx={{ marginLeft: 4, marginRight: 4 }}>
                                <Typography
                                    variant="body1"
                                    color={common.white}
                                    sx={{
                                        textAlign: 'center',
                                        fontFamily: 'Montserrat',
                                    }}
                                >
                                    Building cities and building lives
                                </Typography>
                                <Box sx={{
                                    flex: 1,
                                    marginTop: 1,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                }}>
                                    {dot.map((item, index) => {
                                        return (
                                            <Box key={index} sx={{
                                                width: 16,
                                                height: 2,
                                                marginLeft: 0.5,
                                                marginRight: 0.5,
                                                borderRadius: 1,
                                                backgroundColor: common.white
                                            }} />
                                        )
                                    })}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Stack>
            <DialogStatusComponent
                open={dialog.open}
                status={dialog.status}
                screen={dialog.screen}
                message={dialog.message}
                handleClose={handleCloseDialog}
            />
        </div>
    )
};